import { DataSource } from '@angular/cdk/collections';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { map } from 'rxjs/operators';
import { Observable, of as observableOf, merge } from 'rxjs';
import { MensajeService } from '../servicio/mensaje.service';
import { ConsumeCredencialesService } from '../servicio/consume-credenciales.service';
import { SpinnerService } from 'src/app/spinner.service';
import { promise } from 'protractor';

// TODO: Replace this with your own data model type
export interface TablesItem {
  id: number;
  nombre: string;
  estado?: string;
  acciones?: ActionsItem[];
}

export interface ActionsItem {
  onlyIcon?: true,
  icon?: string;
  name?: string;
  function: string;
  params?: string;
}

// TODO: replace this with real data from your application
const EXAMPLE_DATA: TablesItem[] = [
// const EXAMPLE_DATA = [
  {
    id: 1,
    nombre: 'Colokial',
    estado: 'Activo',
    acciones: [
      {
        onlyIcon: true,
        icon: 'edit',
        function: 'Editar'
      },
      {
        onlyIcon: true,
        icon: 'person',
        function: 'abrirTablaAdmin'
      }
    ]
  },
  {
    id: 2,
    nombre: 'App emplead@',
    estado: 'Activo',
    acciones: [
      {
        onlyIcon: true,
        icon: 'edit',
        function: 'Editar'
      },
      {
        onlyIcon: true,
        icon: 'person',
        function: 'VerUsuarios'
      }
    ]
  },
  {
    id: 3,
    nombre: 'Mi nueva aplicacion',
    estado: 'Inactivo',
    acciones: [
      {
        onlyIcon: true,
        icon: 'edit',
        function: 'Editar'
      },
      {
        onlyIcon: true,
        icon: 'person',
        function: 'VerUsuarios'
      }
    ]
  },
];

/**
 * Data source for the Tables view. This class should
 * encapsulate all logic for fetching and manipulating the displayed data
 * (including sorting, pagination, and filtering).
 */
export class TablesDataSource extends DataSource<TablesItem> {
  data = [];
  paginator: MatPaginator;
  sort: MatSort;

  constructor() {
    super();
  }

  /**
   * Connect this data source to the table. The table will only update when
   * the returned stream emits new items.
   * @returns A stream of the items to be rendered.
   */
  connect(): Observable<TablesItem[]> {
    // Combine everything that affects the rendered data into one update
    // stream for the data-table to consume.
    const dataMutations = [
      observableOf(this.data),
      this.paginator.page,
      this.sort.sortChange
    ];

    return merge(...dataMutations).pipe(map(() => {
      return this.getPagedData(this.getSortedData([...this.data]));
    }));
  }

  /**
   *  Called when the table is being destroyed. Use this function, to clean up
   * any open connections or free any held resources that were set up during connect.
   */
  disconnect() {}

  /**
   * Paginate the data (client-side). If you're using server-side pagination,
   * this would be replaced by requesting the appropriate data from the server.
   */
  private getPagedData(data: TablesItem[]) {
    const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
    return data.splice(startIndex, this.paginator.pageSize);
  }

  /**
   * Sort the data (client-side). If you're using server-side sorting,
   * this would be replaced by requesting the appropriate data from the server.
   */
  private getSortedData(data: TablesItem[]) {
    if (!this.sort.active || this.sort.direction === '') {
      return data;
    }

    return data.sort((a, b) => {
      const isAsc = this.sort.direction === 'asc';
      switch (this.sort.active) {
        case 'nombre': return compare(a.nombre, b.nombre, isAsc);
        case 'estado': return compare(a.estado, b.estado, isAsc);
        case 'id': return compare(+a.id, +b.id, isAsc);
        default: return 0;
      }
    });
  }

  public async obtener_data(creden_serv: ConsumeCredencialesService = null, 
                      msg_serv : MensajeService = null, 
                      recurso: string = '', 
                      params : any = {},
                      spiner : SpinnerService){
    const promesa =  creden_serv.get(recurso, params).toPromise();
    
    await promesa.then(
                (data: any)=>{
                  spiner.spin$.next(false);
                  if (data.data){
                    this.data = data.data;
                  }else if(data.code > 0){
                    msg_serv.ver_mensaje(data.msg, '', msg_serv.TIPO_ERROR);
                  }else{
                    let str_msg ='El recurso consumido no contiene la llave data para la información.';
                    msg_serv.ver_mensaje(str_msg, '', msg_serv.TIPO_ERROR);
                  }
                }
              );

  }
}

/** Simple sort comparator for example ID/Name columns (for client-side sorting). */
function compare(a: string | number, b: string | number, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

/*
 * Auton: Juan David Alzate (juan.alzate@iteria.com.co)
 * Fecha: 02/12/2019
 * Descripción: Parametrizacion en español de los labels del paginador
 */
export function getSpanishPaginatorIntl() {
  const paginatorIntl = new MatPaginatorIntl();

  paginatorIntl.itemsPerPageLabel = 'Items por página:';
  paginatorIntl.previousPageLabel = 'Página anterior';
  paginatorIntl.nextPageLabel = 'Siguiente página';
  paginatorIntl.firstPageLabel = 'Primer página';
  paginatorIntl.lastPageLabel = 'Última página';
  paginatorIntl.getRangeLabel = espRangeLabel;

  return paginatorIntl;
}

/*
 * @Author: Juan David Alzate (juan.alzate@iteria.com.co)
 * @Fecha: 02/12/2019
 * @Description: Parametrizacion en español de los rangos del paginador
 */
const espRangeLabel = (page: number, pageSize: number, length: number) => {
  if (length === 0 || pageSize === 0) {
    return `0 de ${length}`;
  }

  length = Math.max(length, 0);
  const startIndex = page * pageSize;

  // If the start index exceeds the list length, do not try and fix the end index to the end.
  const endIndex = startIndex < length ?
    Math.min(startIndex + pageSize, length) :
    startIndex + pageSize;

  return `${startIndex + 1} - ${endIndex} de ${length}`;
};
